import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import { useProductStore } from '../../ProductProvider';

export default function TheComp() {
    const { pageStatus } = useProductStore();

    const { t } = useLang('theProduct.Banner');
    const itemA = {
        title: t('title'),
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736844744291/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736844599756/a2.jpg',
        label: pageStatus === 'statusA' ? t('label') : t('label_a'),
        btn_text: t('btn'),
        btn_link: 'https://www.youtube.com/embed/at2yA3hKyak?si=j6dD-c4BDQuGLglZ"',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} theme="black" />
        </div>
    );
}
